import { HttpClient, HttpEvent, HttpEventType, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { last, map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class FileDownloaderService {
  constructor(private http: HttpClient) {}

  fetchFile(url: string, updateFunction: (percentDone) => void) {
    let percentDone = 0;
    const req = new HttpRequest('GET', url, {reportProgress: true, responseType: 'blob'});
    return this.http.request(req).pipe(
      map((event: HttpEvent<any>) => {
        if (event.type == HttpEventType.DownloadProgress) {
          percentDone = Math.round((100 * event.loaded) / event.total);
          if (updateFunction) {
            updateFunction(percentDone);
          }
        } else if (event.type === HttpEventType.Response) {
          return event.body;
        }
      }),
      last(),
    );
  }

  startDownload(blob, filename) {
    const a = document.createElement('a');
    a.style.display = 'none';
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => window.URL.revokeObjectURL(url), 5000);
  }

  download(url: string, defaultFilename: string): Observable<void> {
    return this.http.get(url, {
      observe: 'response',
      responseType: 'blob'
    }).pipe(
      tap(response => {
        // 1. Déterminer le nom du fichier
        const contentDisposition = response.headers?.get('content-disposition');
        let filename = defaultFilename;

        if (contentDisposition) {
          const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
          if (matches && matches[1]) {
            filename = matches[1].replace(/['"]/g, '');
          }
        }

        // 2. Déclencher le téléchargement
        const blob = response.body;
        const urlBlob = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = urlBlob;
        a.download = filename;
        a.click();
        setTimeout(() => window.URL.revokeObjectURL(urlBlob), 1000);
      }),
      map(() => void 0)
    );
  }
}
